import type { AsyncThunk } from '@reduxjs/toolkit';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { SponsorApiType, SponsorParameterType, SponsorStoreType } from '../types';
import { fetchSponsors } from '../utils/apis';
import { getSponsorFromApiResponsesAndTag, manipulateSponsorDataFromApi } from '../utils/utils';

export const loadSponsorData: AsyncThunk<
  { global: SponsorApiType[]; other: SponsorApiType[]; local: SponsorApiType[]; sponsor: SponsorApiType | undefined },
  SponsorParameterType,
  unknown
> = createAsyncThunk('sponsor/load', async (data: SponsorParameterType) => {
  const apiResponse = await fetchSponsors(data.cup, data.sponsorPhase);
  const globalSponsors = apiResponse?.filter((s: SponsorApiType) => s.type?.includes('GLOBAL'));
  const otherSponsors = apiResponse?.filter((s: SponsorApiType) => s.type?.includes('OTHER'));
  const localSponsors = apiResponse?.filter((s: SponsorApiType) => s.type?.includes('LOCAL'));
  const sponsor = getSponsorFromApiResponsesAndTag(apiResponse, data.mainDirectory);
  return { global: globalSponsors, other: otherSponsors, local: localSponsors, sponsor };
});

export const sponsors = createSlice({
  name: 'sponsors',
  initialState: {
    isLoaded: false,
    global: [],
    other: [],
    local: [],
    sponsor: null,
  } as SponsorStoreType,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadSponsorData.pending, (state) => ({
      ...state,
      isLoaded: false,
    }));
    builder.addCase(loadSponsorData.fulfilled, (state, { payload: data }) => ({
      ...state,
      global: data.global.map((sponsor) => manipulateSponsorDataFromApi(sponsor)),
      other: data.other.map((sponsor) => manipulateSponsorDataFromApi(sponsor)),
      local: data.local.map((sponsor) => manipulateSponsorDataFromApi(sponsor)),
      sponsor: manipulateSponsorDataFromApi(data.sponsor),
      isLoaded: true,
    }));
    builder.addCase(loadSponsorData.rejected, (state) => ({
      ...state,
      isLoaded: false,
    }));
  },
});
